import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { Organization } from '../model/Organization';

@Injectable()
export class OrganizationFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetAll(): Observable<any> {
        return this._httpClient.get<any>(this._urlBase + 'api/Organization/All');
    }

    GetByOrganization(organizationId: String): Observable<RequestResponse<Organization>> {
        return this._httpClient.get<RequestResponse<Organization>>(
            this._urlBase + 'api/Organization/ByOrganization?organizationId=' + organizationId);
    }

    GetCollectionByTenant(tenantId: number): Observable<RequestResponse<Organization[]>> {
        return this._httpClient.get<RequestResponse<Organization[]>>(
            this._urlBase + 'api/Organization/ByTenant?tenantId=' + tenantId);
    }

    GetCollectionByEmail(email: string): Observable<RequestResponse<Organization[]>> {
        return this._httpClient.get<RequestResponse<Organization[]>>(this._urlBase + 'api/Organization/ByEmployeeEmail?email=' + email);
    }
}
